module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parent"
  }, [_c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', [_vm._v("A little insight in to \"How I Work\". These are components rendered on the same page for easy reference.\n                Bonus! Quick UI check at breakpoints for the entire site in one place.")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('article', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('colors')], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('article', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('contact')], 1)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "container animation--iPad"
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('hero', {
    attrs: {
      "heroClass": "bc"
    }
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "heroClass": "default"
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('article', {
    staticClass: "container",
    attrs: {
      "id": "layouts"
    }
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('aside', [_c('h2', [_vm._v("Select A Source")]), _vm._v(" "), _c('select-source', {
    attrs: {
      "activeSource": _vm.activeSource,
      "sources": _vm.sources
    },
    on: {
      "source-changed": _vm.onSourceChanged
    }
  })], 1)]), _vm._v(" "), _c('project-items', {
    attrs: {
      "projects": _vm.projects
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('article', {
    staticClass: "container"
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', [_vm._v("For other cool stuff that you can do with a styleguide, check out the "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 3500
      }),
      expression: "{ duration: 3500}"
    }],
    attrs: {
      "href": "#layouts"
    }
  }, [_vm._v("Layout Options")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "radio",
    attrs: {
      "for": "one"
    }
  }, [_vm._v("From June 2017 in "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/U85xFTNvxgn"
    }
  }, [_vm._v("Langland Bay")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heroWrapperClass),
      expression: "heroWrapperClass"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "wales"
    },
    domProps: {
      "checked": _vm._q(_vm.heroWrapperClass, "wales")
    },
    on: {
      "change": function($event) {
        _vm.heroWrapperClass = "wales"
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "radio",
    attrs: {
      "for": "two"
    }
  }, [_vm._v("My son as a toddler on a hill\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heroWrapperClass),
      expression: "heroWrapperClass"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "bc"
    },
    domProps: {
      "checked": _vm._q(_vm.heroWrapperClass, "bc")
    },
    on: {
      "change": function($event) {
        _vm.heroWrapperClass = "bc"
      }
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v("You're viewing: " + _vm._s(_vm.heroWrapperClass))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "typography"
    }
  }, [_c('h1', {
    attrs: {
      "id": "headings"
    }
  }, [_vm._v("Headings")]), _vm._v(" "), _c('h1', [_vm._v("h1. Heading")]), _vm._v(" "), _c('h2', [_vm._v("h2. Heading")]), _vm._v(" "), _c('h3', [_vm._v("h3. Heading")]), _vm._v(" "), _c('h4', [_vm._v("h4. Heading")]), _vm._v(" "), _c('h5', [_vm._v("h5. Heading")]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "paragraph"
    }
  }, [_vm._v("Paragraph")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, "), _c('a', {
    attrs: {
      "href": "#",
      "title": "test link"
    }
  }, [_vm._v("test link")]), _vm._v(" adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, "), _c('em', [_vm._v("emphasis")]), _vm._v(" consectetuer adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Colors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Color Variables")]), _vm._v(" "), _c('p', [_vm._v("Note the background color and invert color used for text.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Contact")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Contact Component")]), _vm._v(" "), _c('p', [_vm._v("Section layout will depend on parent. "), _c('code', [_vm._v("class=\"contact\"")]), _vm._v(" will set the width and layout on the landing page. Without the contact container, form responds as seen:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Animations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v("iPad Animated Background**")]), _vm._v(" "), _c('p', [_vm._v("Revisiting this: CSS Keyframe is a crab.")])]), _vm._v(" "), _c('div', {
    staticClass: "component_usage"
  }, [_c('p', [_vm._v("Based on the animation property in the media object. I "), _c('a', {
    attrs: {
      "href": "https://github.com/lesliedoherty/portfolio/commit/853a10b4fcda03f7322ae8d0f145a181dd4a64ac"
    }
  }, [_vm._v("decided")]), _vm._v(" to make use of "), _c('code', [_vm._v("transform: rotateZ(360deg)")]), _vm._v(" to use the GPU power more than the CPU since it was running high at ~40% in Chrome.\n            ")]), _vm._v(" "), _c('p', [_vm._v("The conditional is used inside the for project loop.\n                "), _c('code', [_vm._v("\n                    v-if=\"project.media.animation\"\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Next we evaluate the kind of animation frame we are using:\n                "), _c('code', [_vm._v("\n                    v-if=\"project.media.animation.frame === 'iPad'\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Finally we pass the correct props to the component:\n                "), _c('code', [_vm._v("\n                    :image=\"project.media.animation.image\"\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Hero Component* Needs review")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v("Hero Component")]), _vm._v(" "), _c('p', [_vm._v("Originally had two backgrounds I couldn't decide between: ")])]), _vm._v(" "), _c('div', {
    staticClass: "component_usage"
  }, [_c('p', [_vm._v("Based on the class used when embedding the component.")]), _vm._v(" "), _c('p', [_vm._v("Pass in the following when used to see the picture from Wales (used above the router view so on all pages at the top):\n                "), _c('code', [_vm._v("\n                    class=\"wales\"\n                ")])]), _vm._v(" "), _c('p', [_vm._v("I used a dark background placeholder for the swing photo for now:\n                "), _c('code', [_vm._v("\n                    class=\"bc\"\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Or for the Old Photo Of Me:\n                "), _c('code', [_vm._v("\n                    class=\"default\"\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Project Item Layouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Layout Classes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component_usage"
  }, [_c('p', [_vm._v("Classes are passed in with the data for each project as part of the JSON Schema for projectItem. The following classes and results are available and demonstrated:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("In Progress")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Testing Hero Backgrounds")]), _vm._v(" "), _c('h2', [_vm._v("IN PROGRESS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Pick a class to change the hero background."), _c('br'), _vm._v(" "), _c('small', [_vm._v("Coming Soon: Write up of vue and styleguides to help clients and designers visualize in the browser like this.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-279a386a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/styleguide/Styles.vue
// module id = 82
// module chunks = 0